import React from 'react';
import { Link } from 'react-router-dom';
import './TwoColumnSection.css';

const TwoColumnSection = () => {
  return (
    <section className="content-section">
      <div className="two-column-grid">
        <article className="video-article">
          <Link to="/article/trump-greenland-nato-trouble">
            <div className="video-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=350&fit=crop" 
                alt="Denmark Greenland"
              />
              <div className="play-icon-center">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.6)"/>
                  <polygon points="23,15 23,45 45,30" fill="white"/>
                </svg>
              </div>
              <div className="video-duration">3:59</div>
            </div>
          </Link>
          <p className="video-caption">Watch: Denmark Says a US Attack on Greenland Would Break NATO</p>
          <h3 className="video-title">
            <Link to="/article/trump-greenland-nato-trouble">Trump's Greenland Logic Spells Trouble for Europe and NATO</Link>
          </h3>
          <div className="related-article">
            <p>Denmark Says US Attack on Greenland Would Mean End of NATO</p>
          </div>
        </article>

        <article className="video-article">
          <Link to="/article/trump-venezuela-maduro-china">
            <div className="video-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1569012871812-f38ee64cd54c?w=600&h=350&fit=crop" 
                alt="Venezuela China"
              />
              <div className="play-icon-center">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.6)"/>
                  <polygon points="23,15 23,45 45,30" fill="white"/>
                </svg>
              </div>
              <div className="video-duration">13:46</div>
            </div>
          </Link>
          <p className="video-caption">Watch: Venezuela, China, and Market Risk</p>
          <h4 className="explainer-label">Explainer</h4>
          <h2 className="video-title-large">
            <Link to="/article/trump-venezuela-maduro-china">What Trump's Ousting of Venezuela's Maduro Means for China</Link>
          </h2>
        </article>
      </div>
    </section>
  );
};

export default TwoColumnSection;
